// Agency Routing Types
export const RESPONSIBLE_AGENCY = 'RESPONSIBLE';
export const NOTIFIED_AGENCY = 'NOTIFIED';
